<script setup lang="ts">
// Vue & Plugins
import { ref, computed, Ref } from 'vue'
import { refDebounced } from '@vueuse/core'

// Models
import { SiteID } from '../../../sites/models/site'
import { Tag, TaggableType } from '../../models/tag'
import { useTagQuery } from '../../composables/useTag'
import MultiSelect from 'primevue/multiselect'

const selected = defineModel<Tag[]>('selected', { required: true })

const { siteId, type } = defineProps<{
  siteId: SiteID
  type: TaggableType
}>()

const nameInput = ref('')
const name = refDebounced(nameInput, 500)

const isShown: Ref<boolean> = ref(false)
const enabled = computed(() => isShown.value)

const { data, isFetching } = useTagQuery(
  () => siteId,
  { name, types: () => [type] },
  { enabled: enabled },
)
const tags = computed<Tag[]>(() => data.value?.tags ?? [])

const options = computed(() => {
  // We need to always include the selected tags in the options but ensure that there are no duplicates.
  return [...tags.value, ...selected.value].filter(
    (tag, index, self) => index === self.findIndex((t) => t.id === tag.id),
  )
})
</script>

<template>
  <MultiSelect
    v-model="selected"
    :options="options"
    :loading="isFetching"
    filter
    filter-placeholder="Type to search"
    option-label="name"
    placeholder="tag"
    display="chip"
    @filter="nameInput = $event.value"
    @show="isShown = true"
    @hide="isShown = false"
  />
</template>
